export default __webpack_public_path__ + "d4cf840fcf1b0a7aef0bcd94bbd832d1.svg";